// extracted by mini-css-extract-plugin
module.exports = {"login_holder":"Login_login_holder__DVzBM","login_head":"Login_login_head__1OtJB","title":"Login_title__2xp7g"};